// extracted by mini-css-extract-plugin
export default {"container":"TasksCategoryList_container__O1qMn","column":"TasksCategoryList_column__3j5BN","empty":"TasksCategoryList_empty__qYMgi"};